var resultJson = [
    // {
    //   "name": "austria",
    //   "handle":"austria",
    //   "local": [
    //     {
    //       "title":"Europe & UK eSIM(50 Countries)",
    //       "handle":"eu-uk-bt-esim",
    //       "url":"https://simify.com/collections/austria/products/eu-uk-bt-esim"
    //     },
    //     {
    //       "title":"Europe & UK eSIM",
    //       "handle":"eu-uk-o2-cz",
    //       "url":"https://simify.com/collections/austria/products/eu-uk-o2-cz"
    //     }
    //   ],
    //   "regional": [
    //     {
    //       "title":"Europe & UK",
    //       "handle":"europe",
    //       "url":"https://simify.com/collections/europe"
    //     }
    //   ]
    // },
    // {
    //   "name": "bali",
    //   "handle":"bali",
    //   "local": [
    //     {
    //       "title":"Bali",
    //       "handle":"bali",
    //       "url":"https://simify.com/collections/bali"
    //     },
    //     {
    //       "title":"Indonesia",
    //       "handle":"ind-esim",
    //       "url":"https://simify.com/collections/asia/products/ind-esim"
    //     }
    //   ],
    //   "regional": [
    //     {
    //       "title":"Asia",
    //       "handle":"asia",
    //       "url":"https://simify.com/collections/asia"
    //     }
    //   ]
    // },
    // {
    //   "name":"aland islands",
    //   "handle":"aland-islands",
    //   "country":[
    //     {
    //       "title":"Aland Islands",
    //       "handle":"aland-islands",
    //       "url":"/"
    //     }
    //   ]
    // },
    {
      "name":"africa",
      "handle":"africa",
      "country":[
        {
          "title":"Andorra",
          "search_title":"andorra",
          "handle":"andorra",
          "url":"/search?q=Andorra&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/andorra.svg?v=1710507023"
        },
        {
          "title":"Bolivia",
          "search_title":"bolivia",
          "handle":"bolivia",
          "url":"/search?q=Bolivia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/bolivia.svg?v=1710507131"
        },
        {
          "title":"Chad",
          "search_title":"chad",
          "handle":"chad",
          "url":"/search?q=Chad&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/chad.svg?v=1710507199"
        },
        {
          "title":"Democratic Republic of the Congo",
          "search_title":"democratic-republic-of-the-congo",
          "handle":"democratic-republic-of-the-congo",
          "url":"/search?q=Democratic+Republic+of+the+Congo&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/democratic-republic-of-congo.svg?v=1710507298"
        },
        {
          "title":"Egypt",
          "search_title":"egypt",
          "handle":"egypt",
          "url":"/collections/esim-egypt",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/egypt.svg?v=1676485701"
        },
        {
          "title":"Kenya",
          "search_title":"kenya",
          "handle":"kenya",
          "url":"/search?q=Kenya&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/kenya.svg?v=1676485677"
        },
        {
          "title":"Madagascar",
          "search_title":"madagascar",
          "handle":"madagascar",
          "url":"/search?q=Madagascar&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/madagascar.svg?v=1676485656"
        },
        {
          "title":"Morocco",
          "search_title":"morocco",
          "handle":"morocco",
          "url":"/collections/esim-morocco",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/morocco.svg?v=1676485660"
        },
        {
          "title":"Nigeria",
          "search_title":"nigeria",
          "handle":"nigeria",
          "url":"/search?q=Nigeria&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/nigeria.svg?v=1676485629"
        },
        {
          "title":"Republic of the Congo",
          "search_title":"republic-of-the-congo",
          "handle":"republic-of-the-congo",
          "url":"/search?q=Republic+of+the+Congo&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/republic-of-the-congo.svg?v=1676485617"
        },
        {
          "title":"Seychelles",
          "search_title":"seychelles",
          "handle":"seychelles",
          "url":"/search?q=Seychelles&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/seychelles.svg?v=1676485601"
        },
        {
          "title":"South Africa",
          "search_title":"south africa",
          "handle":"south-africa",
          "url":"/collections/esim-south-africa",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/south-africa.svg?v=1676485599"
        },
        {
          "title":"Tanzania",
          "search_title":"tanzania",
          "handle":"tanzania",
          "url":"/search?q=Tanzania&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/tanzania.svg?v=1676485590"
        },
        {
          "title":"Tunisia",
          "search_title":"tunisia",
          "handle":"tunisia",
          "url":"/search?q=Tunisia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/tunisia.svg?v=1676485588"
        },
        {
          "title":"Uganda",
          "search_title":"uganda",
          "handle":"uganda",
          "url":"/search?q=Uganda&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/uganda.svg?v=1676485577"
        },
        {
          "title":"Zambia",
          "search_title":"zambia",
          "handle":"zambia",
          "url":"/search?q=Zambia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/zambia.svg?v=1676485595"
        }
      ],
      "regional": [
        {
          "title":"Africa",
          "search_title":"africa",
          "handle":"africa",
          "url":"/products/af-es",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/africa.svg?v=1710506551"
        }
      ]
      
    },
    {
      "name":"asia",
      "handle":"asia",
      "country":[
        /*{
          "title":"Bali",
          "search_title":"bali",
          "handle":"bali",
          "url":"/collections/bali",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/bali.svg?v=1676485796"
        },*/
        {
          "title":"Bangladesh",
          "search_title":"bangladesh",
          "handle":"bangladesh",
          "url":"/collections/esim-bangladesh",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/bangladesh.svg?v=1676485760"
        },
        {
          "title":"Indonesia (Bali)",
          "search_title":"indonesia,bali",
          "handle":"indonesia",
          "url":"/collections/esim-indonesia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/indonesia.svg?v=1676485681"
        },
        {
          "title":"Cambodia",
          "search_title":"cambodia",
          "handle":"cambodia",
          "url":"/collections/esim-cambodia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/cambodia.svg?v=1676485742"
        },
        {
          "title":"China",
          "search_title":"china",
          "handle":"china",
          "url":"/collections/esim-china",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/china.svg?v=1676485723"
        },
        {
          "title":"Hong Kong",
          "search_title":"hong kong",
          "handle":"hong-kong",
          "url":"/collections/esim-hong-kong",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/hong-kong.svg?v=1676485697"
        },
        {
          "title":"India",
          "search_title":"india",
          "handle":"india",
          "url":"/collections/esim-india",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/india.svg?v=1676485698"
        },
        {
          "title":"Japan",
          "search_title":"japan",
          "handle":"japan",
          "url":"/collections/esim-japan",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/japan.svg?v=1676485675"
        },
        {
          "title":"Laos",
          "search_title":"laos",
          "handle":"laos",
          "url":"/collections/esim-laos",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/laos.svg?v=1676485658"
        },
        {
          "title":"Macau",
          "search_title":"macau",
          "handle":"macau",
          "url":"/collections/esim-macau",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/macau.svg?v=1676485566"
        },
        {
          "title":"Malaysia",
          "search_title":"malaysia",
          "handle":"malaysia",
          "url":"/collections/esim-malaysia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/malasya.svg?v=1676485655"
        },
        {
          "title":"Philippines",
          "search_title":"philippines",
          "handle":"philippines",
          "url":"/collections/esim-philippines",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/philippines.svg?v=1676485624"
        },
        {
          "title":"Singapore",
          "search_title":"singapore",
          "handle":"singapore",
          "url":"/collections/esim-singapore",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/singapore.svg?v=1676485605"
        },
        {
          "title":"Sri Lanka",
          "search_title":"sri lanka",
          "handle":"sri-lanka",
          "url":"/collections/esim-sri-lanka",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/sri-lanka.svg?v=1676485674"
        },
        {
          "title":"South Korea",
          "search_title":"south korea",
          "handle":"south-korea",
          "url":"/collections/esim-south-korea",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/south-korea.svg?v=1676485598"
        },
        {
          "title":"Taiwan",
          "search_title":"taiwan",
          "handle":"taiwan",
          "url":"/collections/esim-taiwan",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/taiwan.svg?v=1676485592"
        },
        {
          "title":"Thailand",
          "search_title":"thailand",
          "handle":"thailand",
          "url":"/collections/esim-thailand",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/thailand.svg?v=1676485589"
        },
        {
          "title":"Vietnam",
          "search_title":"vietnam",
          "handle":"vietnam",
          "url":"/collections/esim-vietnam",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/vietnam.svg?v=1676485569"
        }
      ],
      "regional": [
        {
          "title":"Asia",
          "search_title":"asia",
          "handle":"asia",
          "url":"/collections/esim-asia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/asia.svg?v=1710506552"
        }
      ]
    },
    {
      "name":"europe & uk",
      "handle":"europe-uk",
      "country":[
        {
          "title":"Albania",
          "search_title":"albania",
          "handle":"albania",
          "url":"/collections/esim-albania",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/albania.svg?v=1676485777"
        },
        {
          "title":"Aland Islands",
          "search_title":"aland islands",
          "handle":"aland-islands",
          "url":"/search?q=Aland+Islands&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/aland-islands.svg?v=1710506802"
        },
        {
          "title":"Austria",
          "search_title":"austria",
          "handle":"austria",
          "url":"/collections/esim-austria",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/austria.svg?v=1676485753"
        },
        {
          "title":"Azores",
          "search_title":"azores",
          "handle":"azores",
          "url":"/search?q=Azores&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/azores-islands.svg?v=1676485759"
        },
        /*{
          "title":"Balearic Islands",
          "search_title":"balearic islands",
          "handle":"balearic-islands",
          "url":"/search?q=Balearic+Islands&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/balearic-islands.svg?v=1676485756"
        },*/
        {
          "title":"Belgium",
          "search_title":"belgium",
          "handle":"belgium",
          "url":"/collections/esim-belgium",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/belgium.svg?v=1676485752"
        },
        {
          "title":"Bulgaria",
          "search_title":"bulgaria",
          "handle":"bulgaria",
          "url":"/collections/esim-bulgaria",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/bulgaria.svg?v=1676485734"
        },
        {
          "title":"Canary Islands",
          "search_title":"canary islands",
          "handle":"canary-islands",
          "url":"/search?q=Canary+Islands&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/canary-islands.svg?v=1676485729"
        },
        {
          "title":"Croatia",
          "search_title":"croatia",
          "handle":"croatia",
          "url":"/collections/esim-croatia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/croatia.svg?v=1676485732"
        },
        {
          "title":"Cyprus",
          "search_title":"cyprus",
          "handle":"cyprus",
          "url":"/collections/esim-cyprus",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/cyprus.svg?v=1676485762"
        },
        {
          "title":"Czech Republic",
          "search_title":"czech republic",
          "handle":"czech-republic",
          "url":"/collections/esim-czech-republic",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/czech-republic.svg?v=1676485703"
        },
        {
          "title":"Denmark",
          "search_title":"denmark",
          "handle":"denmark",
          "url":"/collections/esim-denmark",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/denmark.svg?v=1676485716"
        },
        {
          "title":"England",
          "search_title":"england",
          "handle":"england",
          "url":"/collections/esim-england",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/england.svg?v=1676485709"
        },
        {
          "title":"Estonia",
          "search_title":"estonia",
          "handle":"estonia",
          "url":"/search?q=Estonia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/estonia.svg?v=1676485711"
        },
        {
          "title":"Faroe Islands",
          "search_title":"faroe islands",
          "handle":"faroe-islands",
          "url":"/search?q=Faroe+Islands&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/faroe-islands.svg?v=1676485694"
        },
        {
          "title":"Finland",
          "search_title":"finland",
          "handle":"finland",
          "url":"/collections/esim-finland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/finland.svg?v=1676485695"
        },
        {
          "title":"France",
          "search_title":"france",
          "handle":"france",
          "url":"/collections/esim-france",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/france.svg?v=1676485693"
        },
        {
          "title":"Georgia",
          "search_title":"georgia",
          "handle":"georgia",
          "url":"/collections/esim-georgia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/georgia.svg?v=1676485684"
        },
        {
          "title":"Germany",
          "search_title":"germany",
          "handle":"germany",
          "url":"/collections/esim-germany",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/germany.svg?v=1676485690"
        },
        {
          "title":"Gibraltar",
          "search_title":"gibraltar",
          "handle":"gibraltar",
          "url":"/search?q=Gibraltar&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/gibraltar.svg?v=1676485690"
        },
        {
          "title":"Greece",
          "search_title":"greece,rhodes island",
          "handle":"greece",
          "url":"/collections/esim-greece",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/greece.svg?v=1676485688"
        },
        {
          "title":"Guernsey",
          "search_title":"guernsey",
          "handle":"guernsey",
          "url":"/search?q=Guernsey&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/guernsey.svg?v=1676485685"
        },
        {
          "title":"Hungary",
          "search_title":"hungary",
          "handle":"hungary",
          "url":"/collections/esim-hungary",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/hungary.svg?v=1676485680"
        },
        {
          "title":"Iceland",
          "search_title":"iceland",
          "handle":"iceland",
          "url":"/collections/esim-iceland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/iceland.svg?v=1676485689"
        },
        {
          "title":"Ireland",
          "search_title":"ireland",
          "handle":"ireland",
          "url":"/collections/esim-ireland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/ireland.svg?v=1676485681"
        },
        /*{
          "title":"Isle of Man",
          "search_title":"isle of man",
          "handle":"isle-of-man",
          "url":"/search?q=Isle+of+Man&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/isle-of-man.svg?v=1676485682"
        },
        {
          "title":"Isle of Wight",
          "search_title":"isle of wight",
          "handle":"isle-of-wight",
          "url":"/search?q=Isle+of+Wight&type=product"
        },*/
        {
          "title":"Italy",
          "search_title":"italy,sardinia,sicily",
          "handle":"italy",
          "url":"/collections/esim-italy",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/italy.svg?v=1676485676"
        },
        {
          "title":"Jersey",
          "search_title":"jersey",
          "handle":"jersey",
          "url":"/search?q=Jersey&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/jersey.svg?v=1676485669"
        },
        {
          "title":"Latvia",
          "search_title":"latvia",
          "handle":"latvia",
          "url":"/collections/esim-latvia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/latvia.svg?v=1676485662"
        },
        {
          "title":"Liechtenstein",
          "search_title":"liechtenstein",
          "handle":"liechtenstein",
          "url":"/search?q=Liechtenstein&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/liechtenstein.svg?v=1676485674"
        },
        {
          "title":"Lithuania",
          "search_title":"lithuania",
          "handle":"lithuania",
          "url":"/search?q=Lithuania&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/lithuania.svg?v=1676485661"
        },
        {
          "title":"Luxembourg",
          "search_title":"luxembourg",
          "handle":"luxembourg",
          "url":"/search?q=Luxembourg&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/luxembourg.svg?v=1676485667"
        },
        /*{
          "title":"Madeira",
          "search_title":"madeira",
          "handle":"madeira",
          "url":"/search?q=Madeira&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/madeira.svg?v=1676485650"
        },*/
        {
          "title":"Malta",
          "search_title":"malta",
          "handle":"malta",
          "url":"/collections/esim-malta",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/malta.svg?v=1676485649"
        },
        {
          "title":"Moldova",
          "search_title":"moldova",
          "handle":"moldova",
          "url":"/search?q=Moldova&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/moldova.svg?v=1676485670"
        },
        {
          "title":"Netherlands",
          "search_title":"netherlands",
          "handle":"netherlands",
          "url":"/collections/esim-netherlands",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/netherlands.svg?v=1676485649"
        },
        /*{
          "title":"Northern Ireland",
          "search_title":"northern ireland",
          "handle":"northern-ireland",
          "url":"/search?q=Northern+Ireland&type=product",
        },*/
        {
          "title":"Norway",
          "search_title":"Norway",
          "handle":"norway",
          "url":"/collections/esim-norway",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/norway.svg?v=1676485631"
        },
        {
          "title":"Pakistan",
          "search_title":"pakistan",
          "handle":"pakistan",
          "url":"/collections/esim-pakistan",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/pakistan.svg?v=1676485628"
        },
        {
          "title":"Poland",
          "search_title":"poland",
          "handle":"poland",
          "url":"/collections/esim-poland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/poland.svg?v=1676485625"
        },
        {
          "title":"Portugal",
          "search_title":"portugal,madeira",
          "handle":"portugal",
          "url":"/collections/esim-portugal",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/portugal.svg?v=1676485611"
        },
        {
          "title":"Reunion",
          "search_title":"reunion",
          "handle":"reunion",
          "url":"/search?q=Reunion&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/france.svg?v=1676485693"
        },
        /*{
          "title":"Rhodes Island",
          "search_title":"rhodes island",
          "handle":"rhodes-island",
          "url":"/search?q=Rhodes+Island&type=product",
        },*/
        {
          "title":"Romania",
          "search_title":"romania",
          "handle":"romania",
          "url":"/collections/esim-romania",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/romania.svg?v=1676485617"
        },
        /*{
          "title":"Sardinia",
          "search_title":"sardinia",
          "handle":"sardinia",
          "url":"/search?q=Sardinia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/sardinia.svg?v=1676485613"
        },*/
        {
          "title":"Scotland",
          "search_title":"scotland",
          "handle":"scotland",
          "url":"/collections/esim-scotland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/scotland.svg?v=1676485631"
        },
        /*{
          "title":"Sicily",
          "search_title":"sicily",
          "handle":"sicily",
          "url":"/search?q=Sicily&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/Sicily.svg?v=1676485785"
        },*/
        {
          "title":"Slovakia",
          "search_title":"slovakia",
          "handle":"slovakia",
          "url":"/collections/esim-slovakia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/slovakia.svg?v=1676485625"
        },
        {
          "title":"Slovenia",
          "search_title":"slovenia",
          "handle":"slovenia",
          "url":"/collections/esim-slovenia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/slovenia.svg?v=1676485600"
        },
        {
          "title":"Spain",
          "search_title":"spain,balearic islands",
          "handle":"spain",
          "url":"/collections/esim-spain",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/spain.svg?v=1676485597"
        },
        {
          "title":"Sweden",
          "search_title":"sweden",
          "handle":"sweden",
          "url":"/collections/esim-sweden",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/sweden.svg?v=1676485574"
        },
        {
          "title":"Switzerland",
          "search_title":"switzerland",
          "handle":"switzerland",
          "url":"/collections/esim-switzerland",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/switzerland.svg?v=1676485587"
        },
        {
          "title":"Ukraine",
          "search_title":"ukraine",
          "handle":"ukraine",
          "url":"/search?q=Ukraine&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/ukraine.svg?v=1676485583"
        },
        {
          "title":"United Kingdom (UK)",
          "search_title":"united kingdom (uk),northern ireland,isle of man,wales,isle of wight",
          "search_extra":"uk",
          "handle":"united-kingdom-uk",
          "url":"/collections/esim-united-kingdom",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/united-kingdom.svg?v=1676485575"
        },
        {
          "title":"Vatican City",
          "search_title":"vatican city",
          "handle":"vatican-city",
          "url":"/search?q=Vatican+City&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/vatican-city.svg?v=1676485608"
        },
        /*{
          "title":"Wales",
          "search_title":"wales",
          "handle":"wales",
          "url":"/search?q=Wales&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/wales.svg?v=1676485635"
        }*/
      ],
      "regional": [
        {
          "title":"Europe & UK",
          "search_title":"europe & uk",
          "handle":"europe-uk",
          "url":"/collections/esim-europe",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/europe-uk.svg?v=1710506551"
        }
      ]
    },
    {
      "name":"middle east",
      "handle":"middle-east",
      "country":[
        /*{
          "title":"Dubai",
          "search_title":"dubai",
          "handle":"dubai",
          "url":"/collections/uae-dubai",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/uae-dubai.svg?v=1676485799"
        },*/
        {
          "title":"Armenia",
          "search_title":"armenia",
          "handle":"armenia",
          "url":"/collections/esim-armenia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/armenia.svg?v=1676485790"
        },
        {
          "title":"Azerbaijan",
          "search_title":"azerbaijan",
          "handle":"azerbaijan",
          "url":"/search?q=Azerbaijan&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/azerbaijan.svg?v=1676485779"
        },
        {
          "title":"Bahrain",
          "search_title":"bahrain",
          "handle":"bahrain",
          "url":"/collections/esim-bahrain",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/bahrain.svg?v=1676485751"
        },
        {
          "title":"Israel",
          "search_title":"israel",
          "handle":"israel",
          "url":"/collections/esim-israel",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/israel.svg?v=1676485679"
        },
        {
          "title":"Iraq",
          "search_title":"iraq",
          "handle":"iraq",
          "url":"/collections/esim-iraq",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/iraq.svg?v=1676485686"
        },
        {
          "title":"Jordan",
          "search_title":"jordan",
          "handle":"jordan",
          "url":"/search?q=Jordan&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/jordan.svg?v=1676485673"
        },
        {
          "title":"Kuwait",
          "search_title":"kuwait",
          "handle":"kuwait",
          "url":"/collections/esim-kuwait",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/kuwait.svg?v=1676485797"
        },
        {
          "title":"Kazakhstan",
          "search_title":"kazakhstan",
          "handle":"kazakhstan",
          "url":"/collections/esim-kazakhstan",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/kazakhstan.svg?v=1676485672"
        },
        {
          "title":"Kyrgyzstan",
          "search_title":"kyrgyzstan",
          "handle":"kyrgyzstan",
          "url":"/search?q=Kyrgyzstan&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/kyrgyzstan.svg?v=1676485668"
        },
        {
          "title":"Oman",
          "search_title":"oman",
          "handle":"oman",
          "url":"/collections/esim-oman",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/oman.svg?v=1676485621"
        },
        {
          "title":"Qatar",
          "search_title":"qatar",
          "handle":"qatar",
          "url":"/collections/esim-qatar",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/qatar.svg?v=1676485607"
        },
        {
          "title":"Saudi Arabia",
          "search_title":"saudi arabia",
          "handle":"saudi-arabia",
          "url":"/search?q=Saudi+Arabia&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/saudi-arabia.svg?v=1676485640"
        },
        {
          "title":"Turkey (Türkiye)",
          "search_title":"turkey",
          "handle":"turkey",
          "url":"/collections/esim-turkey",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/turkey.svg?v=1676485579"
        },
        {
          "title":"United Arab Emirates (Dubai)",
          "search_title":"united arab emirates (dubai),uae",
          "search_extra":"uae,dubai",
          "handle":"united-arab-emirates-dubai",
          "url":"/collections/esim-uae-dubai",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/united-arab-emirates.svg?v=1676485576"
        },
        {
          "title":"Uzbekistan",
          "search_title":"uzbekistan",
          "handle":"uzbekistan",
          "url":"/collections/esim-uzbekistan",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/uzbekistan.svg?v=1676485572"
        }
      ],
      "regional": [
        {
          "title":"Middle East",
          "search_title":"middle east",
          "handle":"middle-east",
          "url":"/collections/esim-middle-east",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/middle-east.svg?v=1710506551"
        }
      ]
    },
    {
      "name":"oceania",
      "handle":"oceania",
      "country":[
        {
          "title":"Australia",
          "search_title":"australia",
          "handle":"australia",
          "url":"/collections/esim-australia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/australia.svg?v=1676485761"
        },
        {
          "title":"Fiji",
          "search_title":"fiji",
          "handle":"fiji",
          "url":"/collections/esim-fiji",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/fiji.svg?v=1676485695"
        },
        {
          "title":"New Zealand",
          "search_title":"new zealand",
          "handle":"new-zealand",
          "url":"/collections/esim-new-zealand",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/new-zealand.svg?v=1676485643"
        }
      ],
      "regional": [
        {
          "title":"Oceania",
          "search_title":"oceania",
          "handle":"oceania",
          "url":"/collections/oceania",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/oceania.svg?v=1710506551"
        }
      ]
    },
    {
      "name":"south america",
      "handle":"south-america",
      "country":[
        {
          "title":"Argentina",
          "search_title":"argentina",
          "handle":"argentina",
          "url":"/collections/esim-argentina",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/argentina.svg?v=1676485781"
        },
        {
          "title":"Brazil",
          "search_title":"brazil",
          "handle":"brazil",
          "url":"/collections/esim-brazil",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/brazil.svg?v=1676485757"
        },
        {
          "title":"Chile",
          "search_title":"chile",
          "handle":"chile",
          "url":"/collections/esim-chile",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/chile.svg?v=1676485720"
        },
        {
          "title":"Colombia",
          "search_title":"colombia",
          "handle":"colombia",
          "url":"/collections/esim-colombia",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/colombia.svg?v=1676485732"
        },
        {
          "title":"Costa Rica",
          "search_title":"costa rica",
          "handle":"costa-rica",
          "url":"/collections/esim-costa-rica",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/costa-rica.svg?v=1676485727"
        },
        {
          "title":"Dominican Republic",
          "search_title":"dominican republic",
          "handle":"dominican-republic",
          "url":"/collections/esim-dominican-republic",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/dominican-republic.svg?v=1676485712"
        },
        {
          "title":"Ecuador",
          "search_title":"ecuador",
          "handle":"ecuador",
          "url":"/search?q=Ecuador&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/ecuador.svg?v=1676485789"
        },
        {
          "title":"El Salvador",
          "search_title":"el salvador",
          "handle":"el salvador",
          "url":"/collections/esim-el-salvador",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/el-salvador.svg?v=1676485797"
        },
        {
          "title":"Guadeloupe",
          "search_title":"guadeloupe",
          "handle":"guadeloupe",
          "url":"/search?q=Guadeloupe&type=product",
          "icon_url":""
        },
        {
          "title":"Guatemala",
          "search_title":"guatemala",
          "handle":"guatemala",
          "url":"/collections/esim-guatemala",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/guatemala.svg?v=1676485683"
        },
        {
          "title":"Honduras",
          "search_title":"honduras",
          "handle":"honduras",
          "url":"/collections/esim-honduras",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/honduras.svg?v=1676485677"
        },
        {
          "title":"Nicaragua",
          "search_title":"nicaragua",
          "handle":"nicaragua",
          "url":"/collections/esim-nicaragua",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/nicaragua.svg?v=1676485638"
        },
        {
          "title":"Panama",
          "search_title":"panama",
          "handle":"panama",
          "url":"/collections/esim-panama",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/panama.svg?v=1676485623"
        },
        {
          "title":"Paraguay",
          "search_title":"paraguay",
          "handle":"paraguay",
          "url":"/search?q=Paraguay&type=product",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/paraguay.svg?v=1676485627"
        },
        {
          "title":"Peru",
          "search_title":"peru",
          "handle":"peru",
          "url":"/collections/esim-peru",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/peru.svg?v=1676485619"
        },
        {
          "title":"Puerto Rico",
          "search_title":"puerto rico",
          "handle":"puerto-rico",
          "url":"/collections/esim-puerto-rico",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/puerto-rico.svg?v=1676485615"
        },
        {
          "title":"Uruguay",
          "search_title":"uruguay",
          "handle":"uruguay",
          "url":"/collections/esim-uruguay",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/uruguay.svg?v=1676485573"
        }
      ],
      "regional": [
        {
          "title":"South America",
          "search_title":"south america",
          "handle":"south-america",
          "url":"/collections/esim-south-america",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/south-america.svg?v=1710506552"
        }
      ]
    },
    {
      "name":"usa, canada & mexico",
      "handle":"usa-canada-mexico",
      "country":[
        {
          "title":"Canada",
          "search_title":"canada",
          "handle":"canada",
          "url":"/collections/esim-canada",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/canada.png?v=1664533608"
        },
        /*{
          "title":"Hawaii",
          "search_title":"hawaii",
          "handle":"hawaii",
          "url":"/collections/hawaii",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/hawaii.svg?v=1676485678"
        },*/
        {
          "title":"Mexico",
          "search_title":"mexico",
          "handle":"mexico",
          "url":"/collections/esim-mexico",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/mexico.svg?v=1676485649"
        },
        {
          "title":"United States of America (USA)",
          "search_title":"united states of america (usa),hawaii",
          "search_extra":"usa,hawaii",
          "handle":"united-states-of-america-usa",
          "url":"/collections/esim-usa",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/united-states.svg?v=1676485636"
        },
        /*{
          "title":"United States of America (USA)",
          "search_title":"america",
          "handle":"united-states-of-america-usa",
          "url":"/collections/usa"
        }*/
      ],
      "regional": [
        {
          "title":"USA, Canada & Mexico",
          "search_title":"usa, canada & mexico",
          "handle":"usa-canada-mexico",
          "url":"/collections/esim-usa",
          "icon_url":"https://cdn.shopify.com/s/files/1/0582/6081/6062/files/usa-canada-mexico.svg?v=1710506695"
        }
      ]
    }

  ]